import { EXECUTE_POLICY_ACTION } from '../../constants/actions/policy';

export function executePolicyAction(payload) {
    return {
        type: EXECUTE_POLICY_ACTION,
        payload,
    };
}
